import type { Locale } from "./es"

export const en: Locale = {
  units: {
    unit: "unit",
    units: "units",
    of: "of",
    each: "each",
    total: "total",
    perUnit: "unit",
    soldIn: "Sold in units of",
    min: "Min.",
    stockUnits: "units in stock",
  },
  header: {
    home: "Home",
    shop: "Shop",
    industrialCatalog: "Animal Consumption",
    humanCatalog: "Human Consumption",
    marketplace: "Marketplace",
    shopAll: "Shop All Products",
    about: "About us",
    ourStory: "Our Story",
    services: "Services",
    contact: "Contact",
    login: "Login",
    signup: "Buyer Signup",
    admin: "Administrator",
    tagline: "A destination for every cut",
    profile: "My Profile",
    myAddresses: "My Addresses",
    logout: "Log Out",
    dashboard: "Dashboard",
    adminPanel: "Admin Panel",
    vendorManagement: "Vendor Management",
    myOrders: "My Orders",
  },
  footer: {
    tagline: "A destination for every cut",
    contactTitle: "Contact",
    email: "info@meatbid.mx",
    phone: "+52 668 111 0410",
    address: "Ignacio Pérez sur #49, El Carrizal, 76030, Santiago de Querétaro, Querétaro",
    quickLinks: "Quick Links",
    home: "Home",
    about: "About Us",
    services: "Services",
    contact: "Contact",
    blog: "Blog",
    legal: "Legal",
    privacy: "Privacy Policy",
    terms: "Terms of Use",
    cookies: "Cookie Policy",
    social: "Follow Us",
    copyright: "© 2025 Meatbid Mexico SAPI de CV. All rights reserved.",
    description:
      "Elevating the connection between artisanal producers and discerning chefs since 2012.",
    premiumCuts: "Premium Cuts",
    ourFarms: "Our Farms",
    bespokeOrders: "Bespoke Orders",
    shippingPolicy: "Shipping Policy",
    customerCare: "Customer Care",
    trackOrder: "Track Order",
    contactExpert: "Contact Expert",
    returns: "Returns",
    faqs: "FAQs",
    subscribeTitle: "Subscribe",
    subscribeText: "Subscribe to our newsletter for updates and offers on our products and services.",
    emailPlaceholder: "Your Email",
    joinCollection: "JOIN COLLECTION",
    industrialProtocol: "INDUSTRIAL_PROTOCOL_V1",
  },
  index: {
    hero: {
      title: "Your trusted source for meat products",
      subtitle:
        "Connecting processors, buyers and partners. Reshaping how the meat industry trades",
      question: "What type of buyer are you?",
      description: "Select your category to explore our specialized catalogs",
      shopNow: "Shop Now",
    },
    industrial: {
      title: "Industrial products",
      subtitle: "Byproducts and proteins",
      description: "For pet food, pharmaceutical, and industrial processing industries",
      features: ["High-grade proteins", "Bulk supply", "Custom specifications"],
      cta: "Send us your requirements",
    },
    humanConsumption: {
      title: "Human consumption",
      subtitle: "Meat cuts and products from animal protein",
      description: "For restaurants, retail stores, and direct consumers",
      features: [
        "Premium fresh cuts",
        "Certified farms",
        "Variety of cuts",
        "Food safety standards",
      ],
      cta: "Send us your requirements",
    },
    stats: {
      quality: "Guaranteed quality",
      delivery: "National delivery",
      certified: "Certified suppliers",
    },
  },
  login: {
    backHome: "Back to home",
    welcome: "Welcome back",
    subtitle: "Sign in to your Meatbid account",
    email: "Email address",
    password: "Password",
    signIn: "Sign in",
    signingIn: "Signing in...",
    noAccount: "Don't have an account?",
    signUp: "Sign up here",
    or: "OR",
    success: "Signed in successfully",
    error: "Incorrect credentials. Please try again.",
    emailNotConfirmed: "Verify your email before signing in.",
  },
  loginModal: {
    welcome: "Welcome",
    subtitle: "INDUSTRIAL_ACCESS_V1",
    email: "Email Address",
    password: "Password",
    signIn: "LOGIN",
    or: "Or continue with",
    noAccount: "Don't have an account?",
    signUp: "Register here",
    error: "Incorrect email or password.",
    success: "Session started successfully",
    invalid: "Invalid credentials",
    generalError: "Error logging in",
    emailNotConfirmed: "Verify your email before signing in.",
  },
  buyerSignup: {
    backHome: "Back to home",
    createAccount: "Create Account", // Updated to match design
    joinAs: "Join Meatbid as a buyer",
    signupTitle: "Buyer sign up",
    heroTitle: "Elevating the\nGlobal Meat\nTrade.",
    heroSubtitle: "Join an exclusive industrial marketplace designed for wholesalers, producers, and premium distributors.",
    formSubtitle: "Apply for exclusive access to our premium bidding platform.",
    brandName: "MeatBid",
    fullName: "Full name *",
    companyName: "Company name *",
    phoneNumber: "Phone number *",
    location: "Location",
    selectState: "Select your state",
    businessType: "Business type",
    selectIndustry: "Select your industry",
    email: "Email *",
    password: "Password *",
    creating: "Creating account...",
    createButton: "Create Account", // Updated to match design
    haveAccount: "Already have an account?",
    signIn: "Sign In", // Updated to match design
    signupSuccess: "Account created successfully",
    signupError: "Error creating account. Please try again.",
    checkEmailTitle: "Check your email",
    checkEmailDescription:
      "We sent a verification link to {email}. Activate your account from that email before signing in.",
    goToLogin: "Go to login",
    industries: {
      restaurant: "Restaurant",
      petfood: "Pet food",
      processing: "Food processing",
      retail: "Retail",
      wholesale: "Wholesale",
      other: "Other",
    },
  },
  catalogIndustrial: {
    title: "Animal Consumption",
    subtitle: "Meat products and derivatives for industrial use",
    search: "Search products...",
    contact: "Request Information",
    addToCart: "Add to Cart",
    addedToCart: "Added to cart",
    noResults: "No products found",
    loading: "Loading products...",
    error: "Error loading products from server",
    contactMessage: "We will contact you for more information about",
  },
  catalogHumanConsumption: {
    title: "Human Consumption",
    subtitle: "Premium cuts and meat products for direct consumption",
    search: "Search products...",
    contact: "Request Information",
    addToCart: "Add to Cart",
    addedToCart: "Added to cart",
    noResults: "No products found",
    loading: "Loading products...",
    error: "Error loading products from server",
    contactMessage: "We will contact you for more information about",
  },
  productMarketplace: {
    general: {
      title: "Meatbid Marketplace",
      subtitle: "Explore our premium selection of meat products",
    },
    industrial: {
      title: "Animal Consumption",
      subtitle: "Meat products and derivatives for industrial use",
    },
    human_consumption: {
      title: "Human Consumption",
      subtitle: "Premium cuts and meat products for direct consumption",
    },
  },
  productDetail: {
    back: "Back to catalog",
    contact: "Request Information",
    addToCart: "Add to Cart",
    addedToCart: "Added to cart",
    description: "Description",
    specifications: "Technical Specifications",
    downloadSpec: "Download Data Sheet",
    price: "Price",
    weight: "Approx. Weight",
    stock: "Availability",
    inStock: "In Stock",
    outOfStock: "Out of Stock",
    vendor: "Vendor",
    category: "Category",
    loading: "Loading product details...",
    error: "Error loading product",
    notFound: "Product not found",
    details: "Product Details",
    contactMessage: "We will contact you for more information about",
    loginRequired: "Sign in to request information about this product.",
    inquiryTitle: "Product inquiry",
    inquiryDescription: "Tell us what you need and a MeatBid executive will follow up with the product details.",
    inquiryPhone: "Phone",
    inquiryPhonePlaceholder: "+1 555 000 0000",
    inquiryMessage: "Message",
    inquiryPlaceholder: "Hi, I am interested in this product. I would like to know availability, minimum volume, and delivery timing.",
    inquiryCancel: "Cancel",
    inquirySend: "Send inquiry",
    inquirySuccess: "Inquiry sent. We will contact you soon.",
    inquiryError: "We could not send the inquiry. Please try again.",
    inquiryRateLimit: "Too many requests. Please try again later.",
    inquiryPhoneError: "Enter a valid phone number.",
    inquiryMessageError: "Message must be at least 10 characters.",
    basePrice: "base price",
    ivaLabel: "+ 16% VAT",
    units: "units",
    noDescription: "No description available.",
  },
  common: {
    kg: "kg",
    items: "items",
    itemsCount: "{count} ITEMS",
    dateFormat: "MMM dd, yyyy",
    shortDateFormat: "MMM dd",
    weight: "{weight} KG",
    loading: "Loading...",
    more: "More",
    morePages: "More pages",
    next: "Next",
    previous: "Previous",
    close: "Close",
    menu: "Menu",
    total: "Total",
    price: "Price",
    quantity: "Quantity",
    status: "Status",
    date: "Date",
    email: "Email",
    phone: "Phone",
    company: "Company",
    address: "Address",
    city: "City",
    notes: "Notes",
    actions: "Actions",
    customer: "Customer",
    logisticsProgress: "LOGISTICS PROGRESS",
    unexpectedError: "An unexpected error occurred. We've been notified.",
    all: "All",
    processing: "PROCESSING...",
    newProduct: "New Product",
    newOrder: "New Order",
    addProduct: "Add Product",
  },
  auth: {
    toggleTheme: "Toggle theme",
    userMenu: "User Menu",
    meatbidLogo: "MEATBID",
    alreadyHaveAccount: "Already have an account?",
  },
  vendorOrders: {
    title: "Order Fulfillment",
    queue: "QUEUE: {active} OF {pending}",
    refId: "REF ID:",
    client: "CLIENT",
    shippingAddress: "SHIPPING ADDRESS",
    actionsRequired: "ACTIONS REQUIRED",
    noActions: "No further actions required",
    orderRejected: "Order was rejected",
    viewAuditLog: "View Full Audit Log",
    validateStock: "VALIDATE STOCK",
    rejectOrder: "REJECT ORDER",
    paymentCleared: "PAYMENT CLEARED",
    approveRelease: "APPROVE & RELEASE",
    confirmDelivery: "CONFIRM DELIVERY",
    skuBreakdown: "DETAILED SKU BREAKDOWN ({count} ITEMS)",
    unitQuote: "UNIT QUOTE",
    totalAmount: "TOTAL AMOUNT",
    product: "Product",
    sku: "SKU",
    quantity: "Quantity",
    empty: "You have no active orders",
    loading: "Loading your operations dashboard...",
    orderLabel: "ORDER REF",
    dateLabel: "CREATED",
    subId: "Suborder ID:",
    financials: "FINANCIALS",
    cost: "Unit Quote",
    productCost: "Products",
    tax: "Tax",
    shippingCost: "Shipping cost",
    auditHistory: {
      title: "Audit History",
      description: "Status and payment events recorded for this sub-order.",
      loading: "Loading audit history...",
      empty: "No audit events recorded yet.",
      error: "Unable to load audit history.",
      actor: "Actor",
      actorUser: "User",
      source: "Source",
      requested: "Requested",
      shipping: "Shipping",
      payment: "Payment",
      notAvailable: "N/A",
      actorTypes: {
        Buyer: "Buyer",
        Vendor: "Vendor",
        Webhook: "Payment webhook",
      },
      sources: {
        OrderFactory: "Order placement",
        VendorApi: "Vendor dashboard",
        ConektaWebhook: "Conekta webhook",
      },
      reasons: {
        "Sub-order created": "Sub-order created",
        "Vendor requested status transition": "Vendor requested status transition",
        "Vendor quoted shipping": "Vendor quoted shipping",
        "Payment marked paid": "Payment marked paid",
      },
    },
    margin: "Margin",
    total: "Total Amount",
    status: "Logistics Status",
    address: "Shipping Required",
    updateSuccess: "Logistics stage advanced successfully",
    updateError: "Failed to allocate stage",
    paidBadge: "PAID",
    statuses: {
      Pending: "Pending Approval",
      StockVerified: "Stock Validated",
      ShippingQuoted: "Shipping Quoted",
      PaymentReceived: "Financials Cleared",
      OrderShipped: "In Transit",
      ReadyForPickup: "Ready for Pickup",
      OrderComplete: "Fulfilled / Complete",
      OrderDeclined: "Rejected / Terminated",
    },
    // New pipeline UI elements
    pipeline: "LOGISTICS PROGRESS",
    queueTitle: "Logistics Oversight",
    queueSubtitle: "Validate stock levels and approve fulfillment stages for pending wholesale orders.",
    queueMetrics: "Logistics Queue: {active} active reviews out of {pending} pending",
    actions: {
      validateStock: "VALIDATE STOCK",
      shipOrder: "APPROVE & RELEASE",
      markComplete: "CONFIRM DELIVERY",
      rejectOrder: "REJECT ORDER",
      quoteShipping: "QUOTE SHIPPING",
      markReadyForPickup: "MARK READY FOR PICKUP",
      confirmPickup: "CONFIRM PICKUP",
      awaitingPayment: "AWAITING BUYER PAYMENT",
      shippingCostLabel: "Shipping cost (MXN)",
    },
    supplierTitle: "Supplier Order Tracking",
    supplierComingSoon: "Supplier tracking module coming soon.",
  },
  checkout: {
    title: "Checkout",
    subtitle: "SECURE REVIEW & PAYMENT",
    shipping: "SHIPPING INFORMATION",
    summary: "ORDER SUMMARY",
    subtotal: "SUBTOTAL",
    iva: "VAT (16%)",
    total: "TOTAL AMOUNT",
    placeOrder: "CONFIRM ORDER",
    back: "Back to catalog",
    savedAddresses: "Saved Addresses",
    newAddress: "New Address",
    receiver: "Receiver Name",
    phone: "Phone",
    saveForFuture: "Save this address for future purchases",
    processing: "PROCESSING...",
    paymentMethod: "PAYMENT METHOD",
    payNow: "Pay Now (Secure Gateway)",
    payLater: "Confirm Order & Pay Later",
    payLaterDesc: "An executive will contact you to coordinate payment (Bank Transfer/Cash).",
    securePayment: "Secure Payment Gateway",
    paymentAcknowledge: "Payment via Conekta",
    paymentDesc: "Cards, SPEI & OXXO Pay",
    forNow: "SECURE",
    items: "ITEMS",
    reviewShipping: "Review Shipping",
    shippingTo: "Shipping to",
    orderSummary: "Order Summary",
    totalAmount: "Total Amount",
    paymentInProgress: "Payment in Progress",
    paymentInstructions: "PLEASE COMPLETE YOUR TRANSACTION IN THE SECURE AREA. DO NOT CLOSE OR REFRESH THIS WINDOW.",
    cancelRestart: "CANCEL & RESTART",
    orderSuccess: "Order placed successfully",
    orderError: "Error processing the order",
    emptyCart: "Cart Empty",
    goToCatalog: "GO TO CATALOG",
    support: "SUPPORT",
    supportDesc:
      "UPON ORDER CONFIRMATION, AN AGENT WILL CONTACT YOU TO COORDINATE DELIVERY LOGISTICS.",
    fulfillment: "FULFILLMENT",
    fulfillmentSubtitle: "Choose how you want to receive each item",
    delivery: "Deliver to address",
    pickup: "Pickup at warehouse",
    selectWarehouse: "Select warehouse...",
    pickupAvailableBadge: "Available",
    pickupNotifyBadge: "Notify",
    pickupAvailableNow: "{count} units available now at this warehouse.",
    pickupPartialLive:
      "Only {count} units are available now. You can still select this warehouse and we'll notify you when the rest arrives.",
    pickupNotifyWhenAvailable:
      "No live inventory at this warehouse. You can select it and we'll notify you when inventory is available.",
  },
  adminDashboard: {
    title: "Admin Dashboard",
    providers: "Providers",
    categories: "Categories",
    warehouses: "Warehouses",
    users: "Users",
    settings: "Settings",
    overview: "Overview",
    overviewComingSoon: "Coming Soon: Global control panel and metrics",
    usersComingSoon: "Coming Soon: Global user management",
    settingsComingSoon: "Coming Soon: System configuration",
    quickAddSupplier: "Quick Add: Supplier Purchase",
    quickAddClient: "Quick Add: Client Order",
    supplierOrders: "Supplier Purchases",
    clientOrders: "Client Orders",
    order: "Order",
    meatType: "Meat Type",
    pricePerKg: "Price per kg",
    received: "Received",
    delivered: "Delivered",
    paid: "Paid",
    actions: "Actions",
  },
  warehouseManagement: {
    title: "Warehouses",
    subtitle: "INVENTORY LOCATION MANAGEMENT",
    newWarehouse: "New Warehouse",
    editWarehouse: "Edit Warehouse",
    nameLabel: "Warehouse Name",
    namePlaceholder: "e.g. Central North Warehouse",
    addressLabel: "PHYSICAL ADDRESS",
    cancel: "Cancel",
    save: "Save Warehouse",
    nameCol: "Name",
    locationCol: "Location",
    actionsCol: "Actions",
    loading: "LOADING...",
    empty: "NO WAREHOUSES REGISTERED",
    deleteConfirm: "Are you sure you want to delete this warehouse? This action cannot be undone.",
    successCreate: "Warehouse created successfully",
    successUpdate: "Warehouse updated successfully",
    successDelete: "Warehouse deleted successfully",
    errorCreate: "Error creating warehouse",
    errorUpdate: "Error updating warehouse",
    errorDelete: "Could not delete warehouse. It may have assigned inventory.",
  },
  orderTracking: {
    last30Days: "Last 30 days",
    last3Months: "Last 3 months",
    progress: "Progress",
    orderTotal: "Order Total",
    shippingDelivery: "Shipping & Delivery",
    paymentMethod: "Payment Method",
    product: "Product",
    sku: "SKU",
    unitPrice: "Unit Price",
    executiveConvenience: "MeatBid Executive Agreement",
    estimatedDelivery: "Estimated delivery: coming soon",
    contactExecutive: "Contact Executive",
    downloadInvoice: "Download Invoice",
    trackShipment: "Track Shipment",
    reorder: "Reorder",
    itemsCount: "{count} items",
    productSubtotal: "Products",
    shippingCost: "Shipping cost",
    total: "Total",
    reference: "REF",
    paymentRequired: "Payment required - REF {ref}",
    payAmount: "Pay ${amount}",
    paymentProcessing: "Processing payment",
    pickupShipment: "Warehouse pickup",
    pickupBadge: "Pickup",
    warehouseFallback: "Warehouse #{id}",
    notAvailable: "N/A",
    deliveredAt: "Delivered on {date}",
    reorderAdded: "{count} product(s) added to cart",
    reorderUnavailable: "Could not reorder this order",
    reorderUnavailableDescription: "The order does not include enough product information to add it to the cart.",
    invoiceComingSoon: "Invoice download will be available soon.",
    shipmentTrackingComingSoon: "Shipment tracking will be available soon.",
    paymentLinkUnavailable: "Could not get the payment link",
    paymentStartError: "Error starting payment. Try again.",
    paymentSystemLoadError: "Could not load the payment system.",
  },
  aboutUs: {
    title: "About us",
    subtitle: "RESHAPING THE MEAT INDUSTRY",
    mission: "Our purpose",
    missionText:
      "Transforming the way the world trades meat. At Meatbid we connect processors, buyers and partners through technology that simplifies transactions and improves access.",
    vision: "Our vision",
    visionText:
      "To be the reliable infrastructure that connects animal protein producers and buyers, helping the industry move smarter, faster and with complete transparency.",
    values: "Our values",
    efficiency: "Trade with integrity",
    efficiencyDesc:
      "We are committed to doing what's right. We believe in reliability, quality, security and transparency in every transaction.",
    accessibility: "Advance with sustainability",
    accessibilityDesc:
      "We help the meat industry responsibly manage limited resources, laying the foundation for sustainable growth.",
    innovation: "Innovate with purpose",
    innovationDesc:
      "We use technology and creativity to provide efficiency, simplicity and long-term value to the industry.",
    experience: "Years of experience",
    processors: "Connected Processors",
    transparency: "Total Transparency",
    readyToModernize: "READY TO MODERNIZE YOUR OPERATION?",
    joinLeadingMarketplace: "JOIN MEXICO'S LEADING MARKETPLACE",
    contactUs: "CONTACT US",
  },
  services: {
    heading: "What we do?",
    title: "Services For Buyers",
    subtitle: "CONNECTING THE MEAT INDUSTRY WITH TECHNOLOGY",
    desc: "We connect processors, buyers and partners through technology that simplifies transactions and improves access to meat products.",
    catalogTitle: "Specialized Catalogs",
    industrialCat: "Animal Consumption",
    humanCat: "Human Consumption",
    buyerBenefits: "Benefits for Buyers",
    directAccess: "Product supply",
    directAccessDesc:
      "Explore our specialized catalogs with high-quality products and guaranteed certifications.",
    variety: "Global network access",
    varietyDesc: "Connect with an extensive network of processors and buyers throughout Mexico.",
    convenience: "Lasting models",
    convenienceDesc: "Build strong and sustainable long-term business relationships.",
    quality: "Industrial Logistics",
    qualityDesc: "Comprehensive logistics and distribution management for your meat products.",
    support: "Strategic E-commerce",
    supportDesc:
      "Digitize your sales and purchases with a marketplace that simplifies your transactions.",
    ctaHeadline: "Empowering the Meat Industry through Strategic Connectivity",
    partnerWithUs: "PARTNER WITH US",
    contactSales: "CONTACT SALES",
    viewCatalog: "VIEW CATALOG",
    coreServices: "CORE SERVICES",
  },
  contact: {
    title: "Contact us",
    processing: "PROCESSING...",
    subtitle: "WE'RE HERE TO HELP",
    getInTouch: "Get in touch",
    name: "Full name",
    email: "Email address",
    subject: "Subject",
    message: "Message",
    send: "Send message",
    sending: "Sending...",
    contactInfo: "Contact information",
    address: "Address",
    addressText: "Ignacio Pérez sur #49, El Carrizal, 76030, Santiago de Querétaro, Querétaro",
    phone: "Phone",
    emailAddress: "Email",
    emailText: "info@meatbid.mx",
    hours: "Business hours",
    hoursText: "Monday to Friday: 9:00 AM - 6:00 PM",
    successMessage: "Message sent successfully! We'll contact you soon.",
    messagePlaceholder: "Write your message here...",
    tooManyRequests: "Too many requests. Please try again later.",
    errorMessage: "Failed to send message. Please try again.",
    interactiveMap: "INTERACTIVE MAP",
    subjects: {
      general: "General inquiry",
      seller: "Seller information",
      buyer: "Buyer information",
      partnership: "Partnership opportunities",
      support: "Technical support",
    },
  },
  requirements: {
    title: "Requirements Request",
    subtitle: "Tell us what you need and we'll help you find it",
    description:
      "If you can't find the exact product in our catalog, fill out this form with your technical specifications, volumes, and purchase frequency.",
    form: {
      name: "Full Name",
      email: "Email Address",
      company: "Company",
      requirements: "Requirement specifications",
      placeholder: "Ex: I need 5 monthly tons of beef knuckle, American cut...",
      submit: "Send Requirement",
      sending: "Sending...",
    },
    benefits: {
      title: "Why send your requirement?",
      items: [
        "Access to a global network of verified suppliers",
        "Custom quotes in less than 48h",
        "Logistics and quality assurance included",
        "Savings through volume and consolidation",
      ],
    },
    success: {
      title: "Requirement received!",
      message: "We have received your specifications. A MeatBid advisor will contact you shortly.",
    },
    error: "Error sending requirement",
  },
  order: {
    title: "My Orders",
    subtitle: "PURCHASE STATUS & TRACKING",
    loading: "Loading your orders...",
    empty: "You haven't placed any orders yet.",
    notFound: "No orders found",
    searchPlaceholder: "Search orders...",
    orderId: "ORDER",
    date: "DATE",
    status: "STATUS",
    items: "ITEMS",
    shipping: "SHIPPING ADDRESS",
    payment: "PAYMENT",
    total: "ORDER TOTAL",
    subtotal: "SUBTOTAL",
    iva: "VAT (16%)",
    receiver: "Receiver",
    address: "Address",
    details: "SHIPMENT DETAILS",
    totalOrders: "TOTAL ORDERS",
    shipments: "SHIPMENTS",
    originShipment: "ORIGIN SHIPMENT",
    paymentInfo: "PAYMENT INFO",
    paymentInstructions: "PAYMENT TO BE AGREED WITH A MEATBID EXECUTIVE",
    pipelineProgress: "LOGISTICS PROGRESS",
    financials: "FINANCIALS",
    shipmentBreakdown: "DETAILED SHIPMENT BREAKDOWN ({count} SHIPMENTS)",
    shippingTitle: "SHIPPING & DELIVERY",
    paymentTitle: "PAYMENT INSTRUCTIONS",
    statuses: {
      Pending: "PENDING",
      StockVerified: "VERIFIED",
      ShippingQuoted: "QUOTED",
      PaymentReceived: "PAID",
      OrderDeclined: "DECLINED",
      OrderShipped: "IN TRANSIT",
      ReadyForPickup: "READY FOR PICKUP",
      OrderComplete: "DELIVERED",
    } as Record<string, string>,
  },
  savedAddresses: {
    title: "My Addresses",
    subtitle: "Manage your shipping addresses for faster checkout",
    addAddress: "Add New Address",
    editAddress: "Edit Address",
    deleteConfirm: "Are you sure you want to delete this address?",
    setDefault: "Set as default",
    default: "Default",
    receiver: "Receiver Name",
    phone: "Phone",
    street: "Street",
    extNum: "Ext Number",
    intNum: "Int Number (Optional)",
    neighborhood: "Neighborhood",
    city: "City",
    state: "State",
    zipCode: "ZIP Code",
    save: "Save Changes",
    cancel: "Cancel",
    loading: "Loading addresses...",
    noAddresses: "You have no saved addresses.",
    successAdd: "Address added successfully",
    successEdit: "Address updated successfully",
    successDelete: "Address deleted successfully",
    successDefault: "Default address updated",
    back: "Back",
    validationError: "Please check the errors in the form.",
    edit: "Edit",
    autoFilled: "Auto",
    autoFilledHint: "Filled automatically from the postal code",
    cpLoading: "Looking up postal code...",
    cpNotFound: "Postal code not found",
    selectColonia: "Select a neighborhood",
    coloniaNeedsCp: "Enter a valid postal code",
    statePlaceholder: "Filled from the ZIP code",
    cityPlaceholder: "Filled from the ZIP code",
  },
  heroSection: {
    tagline: "A destination for every cut",
    question: "Are you a Buyer or Seller?",
    buyer: "Buyer",
    seller: "Seller",
    subtitle: "MeatBid: Your Gateway to Mexico's Beef Marketplace",
    description:
      "The leading e-commerce platform connecting beef suppliers and buyers across Mexico. Discover premium cuts directly from independent distributors, automate your sales processes, and access a nationwide network of verified clients. Experience streamlined beef trading with competitive real-time pricing.",
    cta: "Join Mexico's most efficient beef trading ecosystem",
    joinButton: "Get Started",
    stats: {
      waste: "500,000",
      wasteLabel: "Tons of meat wasted in Mexico alone by inefficient markets",
      market: "8.7M",
      marketLabel: "Cattle heads produced annually in Mexico (2025 forecast)",
      efficiency: "$60.67B USD",
      efficiencyLabel: "Revenue in Mexico's meat market (forecast 2025)",
    },
    benefits: {
      title: "Why choose MeatBid?",
      marketplace: "Specialized Marketplace",
      marketplaceDesc:
        "E-commerce platform designed specifically for Mexico's beef industry with features tailored for suppliers and buyers",
      ecommerce: "Easy E-commerce Entry",
      ecommerceDesc:
        "The easiest and most cost-effective way for meat sellers to enter the e-commerce market efficiently",
      national: "National Connection",
      nationalDesc:
        "Connects buyers and sellers at a national level, breaking down geographical barriers and expanding business opportunities",
      efficiency: "Total Efficiency",
      efficiencyDesc:
        "Automate your sales processes, expand your national reach, and connect with thousands of verified buyers effortlessly",
      accessibility: "Direct Access",
      accessibilityDesc:
        "Buyers access independent distributors directly, securing better deals and discovering diverse premium cut options",
      security: "Secure Transactions",
      securityDesc:
        "Safe platform with user verification, protected payments, and quality guarantee for all transactions",
    },
  },
  cartSheet: {
    title: "Shopping Cart",
    empty: "Your cart is empty",
    subtotal: "Subtotal",
    checkout: "Proceed to Checkout",
    clear: "Clear Cart",
    items: "items",
    unit: "unit",
    continueShopping: "Continue Shopping",
  },
  vendorDashboard: {
    title: "My Vendor Dashboard",
    welcome: "Welcome back, {name}",
    subtitle: "Manage your inventory, track orders, and monitor your sales performance.",
    settings: "Settings",
    tabs: {
      inventory: "Inventory",
      addProduct: "Add Product",
      orders: "Received Orders",
      history: "Sales History",
    },
    stats: {
      totalSales: "Total Sales",
      activeProducts: "Active Products",
      pendingOrders: "Pending Orders",
      noInventoryFound: "No inventory found",
      sub: {
        sales: "LAST 30 DAYS",
        products: "IN CATALOG",
        pending: "REQUIRE ACTION",
      },
    },
    performance: "Performance",
    mainMenu: "MAIN MENU",
  },
  categoryManagement: {
    title: "Category Management",
    subtitle: "Manage global product hierarchy",
    add: "New Category",
    edit: "Edit Category",
    nameEs: "Name (Spanish)",
    nameEn: "Name (English)",
    parent: "Parent Category",
    none: "None (Root)",
    save: "Save Changes",
    cancel: "Cancel",
    empty: "No categories",
    actions: "Actions",
    deleteConfirm: "Delete category?",
    successCreate: "Category created",
    successUpdate: "Category updated",
    successDelete: "Category deleted",
    errorDelete: "Delete error: ",
    loading: "Loading...",
    categoryLabel: "Category (ES / EN)",
  },
  providerManagement: {
    title: "Provider Administration",
    subtitle: "Manage global brands and sources for products",
    add: "Add Provider",
    edit: "Edit Provider",
    delete: "Delete",
    name: "Name",
    description: "Description",
    logoUrl: "Logo URL",
    actions: "Actions",
    save: "Save Changes",
    cancel: "Cancel",
    empty: "No providers registered",
    successCreate: "Provider created",
    successUpdate: "Provider updated",
    successDelete: "Provider deleted",
    deleteConfirm: "Delete this provider?",
    loading: "Loading...",
  },
  productCatalog: {
    search: "Search products by name or description...",
    contact: "Request Information",
    addToCart: "Add to Cart",
    addedToCart: "added to cart",
    noResults: "No products found",
    noPageResults: "No products on this page",
    loading: "Loading catalog...",
    error: "Error connecting to server",
    allCategories: "View All",
    categories: "Categories",
    providers: "Providers",
    allProviders: "All providers",
    price: "Price",
    priceRange: "Price Range",
    weightRange: "Weight Range",
    min: "Min",
    max: "Max",
    incVat: "inc. VAT",
    add: "Add",
    sort: {
      label: "Sort by",
      name_asc: "Name (A-Z)",
      price_asc: "Price: Low to High",
      price_desc: "Price: High to Low",
      newest: "Newest Arrivals",
    },
    pagination: {
      label: "Catalog pages",
      previous: "Previous",
      next: "Next",
      page: "Page",
      perPage: "Per page",
      showing: "Showing",
      goToPage: "Go to page",
    },
    contactInfo: "We will contact you for more information about",
  },
  productForm: {
    title: "Publish New Product",
    editTitle: "Edit Product",
    name: "Product Name",
    sku: "SKU / Unique Code",
    description: "Description",
    price: "Selling Price ($)",
    unitCost: "Unit Cost ($)",
    weight: "Weight",
    unit: "Unit",
    images: "Product Images",
    techSpec: "Technical Spec (PDF)",
    uploadImages: "Upload Images",
    uploadSpec: "Upload Spec",
    stock: "Initial Stock",
    lowStock: "Low Stock Threshold",
    leadTime: "Lead Time (Days)",
    safetyStock: "Safety Stock Level",
    taxable: "Taxable (16% VAT)",
    totalPrice: "Total Price (inc. VAT)",
    category: "Category",
    provider: "Provider / Brand",
    selectProvider: "Select provider...",
    selectCategory: "Select category...",
    newCategory: "New category",
    consumptionType: "Consumption Type",
    consumptionHuman: "Human Consumption",
    consumptionIndustrial: "Industrial / Animal",
    originWarehouse: "Origin Warehouse",
    selectWarehouse: "Select a warehouse",
    cancel: "Cancel",
    create: "Create",
    submit: "Publish Product",
    save: "Save Changes",
    success: "Product published successfully",
    successUpdate: "Product updated successfully",
    selectPrimary: "Select primary image",
    validationError: "Please check the errors in the form.",
    currentImages: "Current Images",
    currentTechSpec: "Current Technical Spec",
    viewDocument: "View Document",
    industrialProtocol: "GLOBAL PRODUCT CATALOG INDEXING_V1",
    namePlaceholder: "e.g. Premium Angus Ribeye",
    skuPlaceholder: "e.g. BEEF-RIB-001",
    descPlaceholder: "Describe the cut, origin, characteristics...",
    section1Title: "BASIC INFORMATION",
    section2Title: "FINANCIALS & INVENTORY",
    pricesLabel: "PRICES",
    unitCostDesc: "Acquisition cost per sales unit.",
    priceDesc: "Price published in the store.",
    taxableLabel: "TAXABLE — 16%",
    taxableDesc: "Will be added to the sale price",
    totalPriceIncVat: "TOTAL PRICE INC. VAT",
    inventoryLogisticsLabel: "INVENTORY & LOGISTICS",
    lowStockDesc: "Alert when below this level.",
    safetyStockDesc: "Minimum operational reserve.",
    salesUnitLabel: "SALES UNIT *",
    saleUnitKg: "KG — Kilogram",
    saleUnitLb: "LB — Pound",
    saleUnitG: "G — Gram",
    weightPerUnitLabel: "WEIGHT PER UNIT",
  },
  vendorInventory: {
    loading: "Loading inventory...",
    empty: "You have no published products",
    price: "SELLING PRICE",
    stock: "AVAILABILITY",
    sku: "SKU",
    financials: "METRICS",
    actions: "ACTIONS",
    deleteConfirm: "Delete product?",
    deleteSuccess: "Product deleted",
    edit: "Edit",
    delete: "Delete",
    deleting: "Deleting...",
    manageBatches: "MANAGE BATCHS",
    view: "View:",
    margin: "MARGIN",
    unitCost: "UNIT COST",
    views: { comfortable: "Comfortable", dense: "Dense" },
    filters: { all: "All", low: "Low Stock", out: "Out of Stock" },
  },
  vendorPerformance: {
    title: "Vendor Performance",
    revenueTrend: "Revenue Trend",
    topProducts: "Top Selling Products",
    inventoryHealth: "Inventory Health",
    totalRevenue: "Total Revenue",
    totalOrders: "Completed Orders",
    inventoryTurnover: "Inventory Turnover",
    inventoryToSales: "Inventory to Sales",
    outOfStock: "Out of Stock",
    lowStock: "Low Stock",
    healthy: "Healthy Stock",
    healthyStock: "Inventory healthy",
    restockTitle: "Restock Recommendations",
    restockDesc: "Products below reorder point",
    days: {
      7: "Last 7 days",
      30: "Last 30 days",
      90: "Last 90 days",
    },
    empty: "Not enough data to show statistics.",
    revenue: "Revenue",
    quantity: "Quantity",
    product: "Product",
    loading: "Loading analytics...",
    completedShipments: "Completed shipments",
    efficiencyRatio: "Efficiency ratio",
    capitalTieUp: "Capital tie-up",
    urgentRestock: "Urgent restock",
    belowThreshold: "Items below threshold",
    byQuantity: "By quantity sold",
  },
  batchManagement: {
    title: "Batch Management - ",
    add: "New Batch",
    batchNo: "Batch #",
    qty: "Quantity",
    exp: "Expiration",
    cost: "Unit Cost",
    save: "Create Batch",
    empty: "No batches recorded",
    active: "Active Batches",
    history: "History",
    success: "Batch created",
    outOfStock: "Out of Stock",
    creating: "CREATING...",
    warehouse: "Warehouse",
    noWarehouse: "No warehouse assigned",
  },
  signup: {
    backHome: "Back to home",
    welcome: "Join Meatbid",
    subtitle: "Create an account to start trading meat",
    email: "Email address",
    displayName: "Full name",
    password: "Password",
    signUp: "Sign up",
    signingUp: "Creating account...",
    haveAccount: "Already have an account?",
    signIn: "Sign in",
    success: "Account created!",
    error: "Error creating account",
    checkEmailTitle: "Check your email",
    checkEmailDescription:
      "We sent a verification link to {email}. Activate your account from that email before signing in.",
    goToLogin: "Go to login",
  },
  loginSeller: {
    backHome: "Back to home",
    welcome: "Welcome back, Seller",
    subtitle: "Sign in to your Meatbid seller account",
    email: "Email address",
    password: "Password",
    signIn: "Sign in",
    signingIn: "Signing in...",
    noAccount: "Don't have a seller account?",
    signUp: "Sign up as a seller",
    success: "Welcome!",
    error: "Login failed",
  },
  sellerSignup: {
    backHome: "Back to home",
    createAccount: "Create seller account",
    joinAs: "Join Meatbid as a seller",
    signupTitle: "Seller sign up",
    fullName: "Full name *",
    companyName: "Company name *",
    phoneNumber: "Phone number *",
    email: "Email *",
    password: "Password *",
    creating: "Creating account...",
    createButton: "Create seller account",
    haveAccount: "Already have an account?",
    signIn: "Sign in",
    success: "Account created!",
    error: "Error creating account",
    checkEmailTitle: "Check your email",
    checkEmailDescription:
      "We sent a verification link to {email}. Activate your account from that email before signing in.",
    goToLogin: "Go to login",
  },
  verifyEmail: {
    backHome: "Back to home",
    loadingTitle: "Verifying email",
    loadingDescription: "We are validating your account verification link.",
    successTitle: "Email verified",
    successDescription: "Your account is active. You can now sign in.",
    errorTitle: "Verification failed",
    errorDescription: "The link is invalid or expired. Request a new verification link.",
    goToLogin: "Go to login",
  },
  adminLogin: {
    title: "Administrator Access",
    email: "Email Address",
    password: "Password",
    verifying: "Verifying...",
    signIn: "Login",
    success: "Access granted",
    error: "Access error",
  },
  featuredCategories: {
    title: "Explore Categories",
    subtitle: "Premium wholesale cuts for your business",
    products: "PRODUCTS",
    items: {
      beef: "Beef Cuts",
      pork: "Pork Selection",
      poultry: "Poultry",
      lamb: "Lamb & Mutton",
      specialty: "Specialty",
    },
  },
  featuredProducts: {
    title: "Top Items",
    subtitle: "Trending and high-demand products",
    viewAll: "View All Catalog",
  },
  seo: {
    defaultTitle: "MeatBid - High Volume Meat Marketplace in Mexico",
    defaultDesc:
      "Mexico's leading platform for wholesale meat trading. Connecting processors and distributors with high-quality products and competitive prices.",
    homeTitle: "MeatBid | Large Scale Meat Trading in Mexico",
    homeDesc:
      "Bulk meat sales in Mexico. We connect top suppliers with industrial and commercial buyers. Guaranteed quality and efficient logistics.",
    catalogTitle: "Wholesale Meat Catalog | MeatBid Mexico",
    catalogDesc:
      "Explore our variety of high-quality beef, pork, and chicken cuts. Constant supply for the industrial and restaurant sectors in Mexico.",
    aboutTitle: "About Us | MeatBid's Mission in Mexico",
    aboutDesc:
      "Get to know MeatBid, the trading company that is revolutionizing the Mexican meat industry through technology and transparency.",
    contactTitle: "Wholesale Sales Contact | MeatBid Mexico",
    contactDesc:
      "Contact our experts for bulk meat quotes. Specialized service for the Mexican meat industry.",
    keywords:
      "meat mexico, wholesale meat, high volume meat, meat suppliers mexico, beef cuts mexico, meat trading, meat industry mexico",
  },
  notFound: {
    title: "404",
    message: "Oops! Page not found",
    backHome: "Return to Home",
  },
}

